import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actionCreators from "../actions/actionCreators.js";


import App from "../components/App";


function mapStateToProps(state){
	//console.log("Connecting state", state.series);
	return {
		groups: state.data.groups,
		otherDepartments: state.data.otherDepartments,
		lang: state.data.lang,
		fID: state.data.userInfo.id,
		modules: state.data.modules || [],
		justLogged: state.data.justLogged,
		rank: state.data.userInfo.rank,
		auth: state.data.auth
	}
}

function mapDispatchToProps(dispatch){
	return bindActionCreators(actionCreators, dispatch);
}


const AppContainer = connect(mapStateToProps, mapDispatchToProps)(App);

export default AppContainer;


// WEBPACK FOOTER //
// ./src/containers/AppContainer.js